import { SortDirection } from '@angular/material/sort';
import { SubentityStateModel } from 'app/projects/subentity/src/lib/models/subentity.state-model';

export class CourseOfferingExecutionsStateModel extends SubentityStateModel {
    totalCount: number;
    sortBy: string;
    sortOrder: SortDirection;
    pageSize: number;
    pageNumber: number;

    constructor() {
        super();
    }
}
